<template>
  <div class>

    <!-- Custom Content Modal -->
    <b-modal
      id="custom-modal"
      v-model="showModal"
      title="Custom Modal Title"
      hide-footer
      size="xl"
    >
      <!-- Custom HTML Content -->
      <div class="custom-content table-responsive">
        <h3 class="text-primary">Hello, Vue with BootstrapVue!</h3>
        <p>
          This is a custom modal with HTML content. You can include anything here, such as forms, tables, or even other Vue components.
        </p>
        <ul>
          <li>Custom list item 1</li>
          <li>Custom list item 2</li>
          <li>Custom list item 3</li>
        </ul>

        <!-- Buttons or actions -->
        <div class="text-right mt-3">
          <b-button variant="secondary" @click="showModal = false">Close</b-button>
          <!-- <b-button variant="success" @click="handleSave">Save</b-button> -->
        </div>
      </div>
    </b-modal>


    <div class="row">
      <div class="col-lg-12">

        <div class="card shadow mb-1">
          <div class="card-header py-3 d-flex flex-row justify-content-between">
            <p class="m-0 text-primary">
              <span v-if="!isBusy">
                {{ txt("Showing") }} 
                {{ `${messages.length > 0 ? tOffset + 1 + "-" : "0"}` }}
                {{ messages.length > 0 ? messages.length + tOffset : "" }} 
                <i class="fas fa-check"></i>
                {{ messageTotal }} {{ txt("Found") }} 
              </span>
              <span v-if="isBusy">
                <i class="fas fa-spinner fa-spin"></i>
                {{ txt("Loading..") }}
              </span>
            </p>
  
            <!-- <button
                    class="btn btn-primary w-10"
                  > <i class="far fa-paper-plane"></i> Send message</button>-->
            <!-- <router-link class="btn btn-primary w-10" :to="{name:'SendMessage'}">
                    <i class="far fa-paper-plane"></i>
                    <span class="p-1">{{txt('Send message')}}</span>
                  </router-link> -->
          </div>
          <div class="card-body container-fluid" style="padding-top: 0; font-size: 15px">
            <form class=" mt-3 mb-3" v-on:submit.prevent="(e) => {e.preventDefault(); return false}">
              <!-- search: 1st row -->
              <div class="row fixed-top-" id="search-1" :class="{'fixed-top': stickSearch}">
              <div class="col-md-4">
                <div class="row hide-when-fixed">
                  <div class="col-md-6 col-6">
                    <label>{{ txt("Start Date") }}</label>
                    <datepicker :placeholder="txt('Select Date')" :format="format" v-model="dateFrom" :language="dLanguages[language]" id="sdt"></datepicker>
                  </div>
                  <div class="col-md-6 col-6">
                    <label>{{ txt("End Date") }}</label>
                    <datepicker :placeholder="txt('Select Date')" v-model="dateTo" :format="format" :language="dLanguages[language]" name="endDate" id="edt"></datepicker>
                  </div>
                </div>
                <a href="#" class="btn btn-sm btn-info mt-2 mr-1 hide-when-fixed" @click="filterUpdate('-1 Day')">{{ txt("Day -1") }}</a
                      >
                      <a
                        href="#"
                        class="btn btn-sm btn-info mt-2 mr-1 hide-when-fixed"
                        @click="filterUpdate('today')"
                        >{{ txt("Today") }}</a
                      >
                      <a
                        href="#"
                        class="btn btn-sm btn-info mt-2 mr-1 hide-when-fixed"
                        @click="filterUpdate('+1 Day')"
                        >{{ txt("Day +1") }}</a
                      >
                      <a
                        href="#"
                        class="btn btn-sm btn-info mt-2 mr-1 hide-when-fixed"
                        @click="filterUpdate('recent')"
                        >{{ txt("Recent") }}</a
                      >
                      <a
                        v-if="isAdmin"
                        href="#"
                        class="btn btn-sm btn-warning mt-2 mr-1 hide-when-fixed"
                        @click="filterUpdate('latest_update')"
                        >{{ txt("Latest update") }}</a
                      >
                    </div>
                    <div class="col-md-2 col-6 hide-when-fixed">
                      <label>{{ txt("Status") }}</label>
                      <select class="browser-default custom-select" v-model="filters.status">
                        <option selected value>{{ txt("Any") }}</option>
                        <option value="PENDING">{{ txt("PENDING") }}</option>
                        <option value="SUCCESS">{{ txt("SUCCESS") }}</option>
                        <option value="FAILED">{{ txt("FAILED") }}</option>
                        <option v-if="isAdmin" value="FAILED_WITH_EXCEPTION">{{ txt("FAILED_WITH_EXCEPTION") }}</option>
                        <option value="CANCELLED">{{ txt("CANCELLED") }}</option>
                      </select>
                    </div>
                    <div class="col-md-2 col-6 hide-when-fixed">
                      <label>{{ txt("Channel") }}</label>
                      <select class="browser-default custom-select" v-model="filters.channel">
                        <option selected value>{{ txt("Any") }}</option>
                        <option value="sms">SMS</option>
                        <option value="whatsapp">WhatsApp (All)</option>
                        <option value="whatsapp_v1">WhatsApp Hosted</option>
                        <option value="whatsapp_waba">WhatsApp WABA</option>
                        <option value="email">Email</option>
                      </select>
                    </div>

                    <div class="col-md-4 hide-when-fixed" v-if="isAdmin">
                      <label>{{ txt("Account") }}</label>
                          <v-select 
                            :getOptionLabel="getAccountLabel"
                            :options="accountsOptions" 
                            v-model="filters.accountId" 
                            :reduce="r => r._id" 
                            >
                          </v-select>
                          
                    </div>

                    <button class="btn btn-primary btn-sm w-100 mt-2 col-md-4 show-when-fixed" @click="searchRefresh('click search fixed')">
                      {{ txt("Search") }}
                    </button>

                    </div>

                    <!-- search: 2nd row -->
                    <div class="row">

                    <div class="col-md-2 col-6" v-if="isAdmin">
                      <label>{{ txt("Phone ID") }}</label>
                      <b-form-select
                        :options="phoneOptions()"
                        v-model="filters.phoneId"
                      ></b-form-select>
                    </div>
                    <div class="col-md-3 col-6" v-if="isAdmin">
                      <label>{{ txt("Carrier Name") }}</label>
                      <v-select multiple
                        :options="carrierNameOptions()"
                        v-model="filters.carrierNames"
                        :reduce="r => r.value" 
                      ></v-select>
                      <!-- <pre>{{filters.carrierNames}}</pre> -->
                    </div>
                    <div class="col-md-2 col-6" v-if="isAdmin">
                      <label>{{ txt("SMS Provider") }}</label>
                      <b-form-select
                        :options="providerOptions()"
                        v-model="filters.provider"
                      ></b-form-select>
                    </div>
                    <div class="col-md-2 col-6" v-if="isAdmin">
                      <label>{{ txt("SIM Method") }}</label>
                      <b-form-select
                        :options="methodOptions()"
                        v-model="filters.method"
                      ></b-form-select>
                      <!-- <br> -->
                      <!-- <b-button-group size="sm">
                        <b-button v-for="i in methodOptions()" v-on:click="selectMethod(i)" :value="i" class="btn-sm btn-info">{{i.text}}</b-button>
                      </b-button-group> -->
                    </div>
                    <div class="col-md-2" v-if="isAdmin">
                      <!-- <label>{{ txt("Auto refresh") }} <i>{{ lastRefreshed }}</i></label> -->
                      <b-form-checkbox v-model="autoRefresh">
                        {{txt('Auto refresh')}} 30s
                        <br>
                        <i>{{ lastRefreshed }}</i>
                      </b-form-checkbox>
                    </div>
      
                    <div class="col-md-12 mb-2"></div>
      
                    <div class="col-md-1 col-3">
                      <label>{{ txt("Country code") }}</label>
                      <b-form-select
                        :options="countryCodes"
                        v-model="filters.countryCode"
                      ></b-form-select>
                    </div>
                    <div class="col-md-2 col-9">
                      <label>{{ txt("Phone number") }}</label>
                      <b-form-input
                        type="text"
                        v-model="filters.phoneNumber"
                        placeholder="e.g. 6111 2222"
                      ></b-form-input>
                    </div>
                    <div class="col-md-2 col-6">
                      <label>{{ txt("Message direction") }}</label>
                      <b-form-select
                        :options="messageDirectionOptions"
                        v-model="filters.type"
                      ></b-form-select>
                    </div>
                    <div class="col-md-2 col-6">
                      <label>{{ txt("Message contains") }}</label>
                      <b-form-input v-model="filters.message"></b-form-input>
                    </div>
                    <div class="col-md-3">
                      <label>{{ txt("Message ID") }}</label>
                      <b-form-input v-model="filters._id"></b-form-input>
                    </div>
      
                    <!-- <div class="col-md-1"></div> -->
      
                    <div class="col-md-2">
                      <label>&ensp;</label>
                      <div class="form-group">
                        <button class="btn btn-secondary mt-2 pl-3 pr-3" @click="clearFilters(true, true)">
                          {{ txt("Clear") }} 
                          <span class="badge bg-white text-secondary" v-if="this.lastFilters !== null">undo</span>
                        </button>
                        &nbsp;
                        <button class="btn btn-primary mt-2 pl-4 pr-4" @click="searchRefresh('click search')">
                          {{ txt("Search") }}
                        </button>

                        <!-- view search history button -->
                        <!-- <button class="btn btn-primary mt-2 pl-4 pr-4" @click="viewSearchHistory()">
                          {{ txt("Search History") }}
                        </button>

                        <b-modal id="search-history" title="BootstrapVue">
                          <p :v-for="i in searchHistories">
                            {{ searchHistories[i] }}
                          </p>
                          <p class="my-4">Hello from modal!</p>
                        </b-modal> -->

                      </div>
                      
                    </div>
                    </div>

                  </form>
      
                  <hr />

                  <!-- Summary Section -->
                  <div class="row mb-3" v-if="summary && isAdmin">
                    <div class="col-lg-6">
                      <div class="card shadow">
                        <div class="card-header py-3">
                          <h6 class="m-0 font-weight-bold text-primary">By Account</h6>
                        </div>
                        <div class="card-body">
                          <canvas id="messageStatsChart" height="80"></canvas>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="card shadow">
                        <div class="card-header py-3">
                          <h6 class="m-0 font-weight-bold text-primary">By Channel</h6>
                        </div>
                        <div class="card-body">
                          <canvas id="messageChannelChart" height="80"></canvas>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="card shadow">
                        <div class="card-header py-3">
                          <h6 class="m-0 font-weight-bold text-primary">By Price</h6>
                        </div>
                        <div class="card-body">
                          <canvas id="messagePriceChart" height="80"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div 
                    v-if="isAdmin && selectedRowCount"
                    class="bulk-control col-md-12 fixed-bottom text-right"
                  >
                    <div class="bulk-control-inner bulk-control-inner-tmp form-row- pt-2 pb-2" :style="blukControlStyle">

                    <a class="btn btn-sm btn-success text-white"
                     ref="transferButton"
                     @click="updateResultSelected('success')">
                      Success
                      <i class="badge badge-info text-dark bg-white">{{selectedRowCount}}</i>
                    </a>
                    &nbsp;
                    <a class="btn btn-sm btn-danger text-white"
                     ref="transferButton"
                     @click="updateResultSelected('failed')">
                      Failed
                      <i class="badge badge-info text-dark bg-white">{{selectedRowCount}}</i>
                    </a>
                    &nbsp;
                    <a class="btn btn-sm btn-primary"
                     ref="transferButton"
                     @click="transferSelectedJob()">
                      Transfer
                      <i class="badge badge-white">{{selectedRowCount}}</i>
                    </a>
                    &nbsp;
                    
                    <b-form-select  class="col-3 col-md-2 form-control form-control-sm"
                            :options="phoneForTransferOptions()" 
                            v-model="phoneSelectedForTransfer" 
                            >
                      </b-form-select>
                    &nbsp;

                    <button class="btn btn-sm btn-light" @click="clearSelectedRows()">Clear</button>
                    &nbsp;
                    <button class="btn btn-sm btn-light" @click="selectAllRows()">Select All</button>
                  </div>
                  </div>
      
                  <div class="row" id="result-table">

                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :perPage="perPage"
                        first-text="<<"
                        prev-text="<"
                        next-text=">"
                        last-text=">>"
                        limit="10"
                      ></b-pagination>
      
                    <div class="table-responsive msg">
                      
                      <b-table
                        sticky-header-not_working="1200px"
                        ref="table"
                        id="table-transition-example"
                        :busy="isBusy"
                        :items="search"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        primary-key="identifier"
                        :selectable="true"
                        @row-selected="onRowSelected"
                      >
      
                        <template #table-busy>
                          <div class="text-center text-info">
                            <b-spinner class="align-middle"></b-spinner>
                            &nbsp;
                            <!-- <strong>{{txt('Loading')}}</strong> -->
                          </div>
                        </template>

<template #cell(_id)="row">
  <span class="text-primary" :title="row.value.jobId">{{ row.value.id }}</span>
                              
  <div>
    <span style="cursor: pointer" v-if="row.value.jobId" 
      @click="copy" class="badge badge-secondary" title="jobId"
      :data-value="row.value.jobId">
      {{ row.value.jobId }}
      <i :data-value="row.value.jobId" class="fas fa-fw fa-copy"></i>
    </span>
    
    <br v-if="isAdmin">  

    <a class="ml-1" target="_blank" v-if="getArenaUrlByMessage(row.value.item) && isAdmin" 
      :href="getArenaUrlByMessage(row.value.item)">Arena</a>
      
    <a class="ml-1 text-success-" target="_blank" v-if="isAdmin && row.value.usedDevice" 
      @click="transferJob(row.value.item)"> 
      <i class="fas fa-random- fa-arrow-right"></i> Transfer
    </a>

    <a v-if="isAdmin && row.value.usedDevice" class="ml-1" @click="transferJobPreview(row.value.jobId)">Preview</a>

    <!-- <a class="ml-1 text-success" target="_blank" v-if="isAdmin && row.value.usedDevice" 
      @click="updateResult(row.value.item, 'success')">
      <i class="fas fa-random- fa-arrow-right"></i> SUCCESS
    </a>
    <a class="ml-1 text-danger" target="_blank" v-if="isAdmin && row.value.usedDevice" 
      @click="updateResult(row.value.item, 'failed')">
      <i class="fas fa-random- fa-arrow-right"></i> FAILED
    </a> -->

<!-- <pre>{{row.item|json}}</pre> -->
<!-- <pre>{{row.value|json}}</pre> -->
<!-- <pre>{{row.value.tags|json}}</pre> -->
    <br>
    <span class="badge badge-info" 
      :class="{
        'badge-warning': (
          i.includes('_new') || i.includes('invalid_contact')
        )
        }" 
      v-for="i in row.value.timingTags"
      v-if="row.value.hasTimingTags && isAdmin">
      <i class="fas fa-tag"></i>
      {{i}}
      </span> 

    <a class="badge badge-info" 
      :style="row.value.isTransferred && 'background: var(--blue)'"
      :foo="{'background: var(--blue)': true}"
      :href="row.value.vncLink"
      target="_blank"
      v-if="isAdmin && row.value.usedDevice">
      <i class="fas fa-random- fa-arrow-right-" :class="{'fa-random': row.value.isTransferred, 'fa-arrow-right': !row.value.isTransferred}"></i>
      {{row.value.usedDevice}}
      </a> 
    <a class="badge badge-info" 
      :style="row.value.isTransferred && 'background: var(--blue)'"
      :href="row.value.novncLink"
      target="_blank"
      v-if="isAdmin && row.value.usedDevice">
      <i class="fas" :class="{'fa-random': row.value.isTransferred, 'fa-arrow-right': !row.value.isTransferred}"></i>
      noVNC
      </a> 

    <!-- <pre>{{row.item.job|json}}</pre> -->
    <span class="badge badge-info" 
      v-if="row.item.job.provider && isAdmin">{{ row.item.job.provider }}</span> 

    <span class="badge badge-secondary" 
      v-if="row.item.job.providerMessageId && isAdmin" @click="copy" :data-value="row.item.job.providerMessageId">
        {{ row.item.job.providerMessageId }} 
        <i class="fas fa-fw fa-copy" @click="copy" :data-value="row.item.job.providerMessageId"></i>
    </span> 

    <span class="badge badge-secondary" 
      v-if="row.value.item.waMessageId && isAdmin" @click="copy" :data-value="row.value.item.waMessageId">
        {{ row.value.item.waMessageId }} 
        <i class="fas fa-fw fa-copy" @click="copy" :data-value="row.value.item.waMessageId"></i>
    </span> 

    <span class="badge badge-info ml-1" 
      v-if="row.item.job.method && isAdmin">{{ row.item.job.method }}</span> 
    <span class="badge badge-info ml-1" 
      v-if="isAdmin && row.item.job.phoneId">{{ row.item.getPhoneName() }}</span>
    
    <br />
    <span class="badge badge-info ml-1"
      v-if="row.value.accountUsername && isAdmin">
      <i class="fas fa-user"></i> {{ row.value.accountUsername }}
    </span>
    
  </div>

</template>

<template #cell(fromPhoneNumber)="row">

  <!-- from phone -->
  <span :class="row.value.fromPhoneClass">{{ row.value.myPhone }}</span>
  &nbsp; 
  <a v-if="isAdmin" :href="row.value.myPhoneWaLink" target="_blank" class="badge badge-success" > 
    <i class="fab fa-whatsapp"> </i>
  </a>
  
  <!-- their phone -->
  <br>
  <span class="ml-1" v-html="row.value.iconClass"></span>

  <span class="ml-1" style="white-space: pre" :class="row.value.toPhoneClass">{{ row.value.theirPhone }}</span>
  &nbsp; 
  <a v-if="isAdmin" :href="row.value.theirPhoneWaLink" target="_blank" class="badge badge-success" 
    @click="copy" :data-value="row.item.message"
  > 
    <i class="fab fa-whatsapp" :data-value="row.item.message"> </i>
  </a>
  
  <!-- &nbsp; 
  <a v-if="isAdmin" :href="row.value.theirPhoneTLink" target="_blank" class="badge badge-info" > 
    <i class="fab fa-telegram"> </i>
  </a> -->

  <!-- search their phone -->
  &nbsp; 
  <a href="#" class="badge badge-info">
    <i class="fa fa-search " @click="addTheirPhoneToFilter($event, row)"> </i>
  </a>

  <span class="badge badge-info ml-1" 
      v-if="isAdmin && row.item.carrierName"> <i class="fa fa-fw fa-satellite-dish"></i> {{ row.item.getCarrierShortName() }}</span>

  <!-- copy msg -->
  <div class="clearfix"></div>
  <a class="mt-1" v-if="row.item.message && isAdmin"  @click="copy" :data-value="row.item.message">
    <i class="fas fa-fw fa-copy"></i>
    COPY MSG
  </a>
  
</template>

<template #cell(phoneNumber)="row">
  <div class="text-left">
    <span v-html="row.value.iconClass"></span>
    <span class="text-primary">
                              {{ row.value.phone }}
                            </span>
  </div>
</template>

<template #cell(channel)="row">
  <span class="text-primary">
                            {{ row.value }}
                          </span>
</template>

<template v-slot:cell(status)="row">

  <span class="badge text-sm" :class="row.value.serverity">{{ txt(row.item.status) }}</span>

  <span class="badge badge-danger ml-1" v-if="row.value.failedReason">{{ row.value.failedReason }}</span>

  <!-- <div class="clearfix"></div> -->

  <span class="badge ml-1" v-if="row.item.duration && isAdmin"
    :class="row.value.durationClass"  :title="row.value.durationTitle"
    >{{ row.value.displayDuration }}</span>

  <span class="badge badge-info text-sm ml-1" v-if="row.item.readAt">READ</span>
  <span class="badge badge-info text-sm ml-1" v-if="row.item.WABA && row.item.session" :title="row.item.sessionSince">SESSION</span>
  <span class="badge badge-info text-sm ml-1" v-if="row.item.WABA && !row.item.session && row.item.type === 'outgoing'">BIZ INIT</span>
  <span class="badge badge-info text-sm ml-1" v-if="row.item.WABA && !row.item.session && row.item.type === 'incoming'">USER INIT</span>

  <span class="badge badge-warning text-sm ml-1" v-if="row.value.isNewChat && isAdmin">{{ txt('New contact') }}</span>

  <div class="text-left">
    <!-- <span class="blink" :class="data.value.className"
      >&nbsp;</span
    > -->
    <!-- <span class="text">{{
      txt(data.value.displayText)
    }}</span>
  --> &nbsp;
  <!-- <span class="badge badge-danger" :v-if="data.value.failedReason">{{ data.value.failedReason }}</span> -->
  
  </div>
</template>

<template v-slot:cell(createdAt)="data">
   {{ data.value }}
</template>
<template v-slot:cell(updatedAt)="data">
   {{ data.value }}
</template>

<template v-slot:cell(channel)="data">
   {{ data.value }}
   <span class="badge badge-info text-sm ml-1" v-if="data.item.WABA">WABA</span>
</template>

<template v-slot:cell(message)="row">
  <div class="text-dark">
    <span v-if="row.item.quotedMessage" class="mb-0 text-xs text-gray">
      <i class="fas fa-fw fa-quote-left"></i>
      {{ row.item.quotedMessage }}
    </span>
    <br v-if="row.item.quotedMessage">
    {{ row.item.message }}
    <i v-if="row.item.message" class="fas fa-fw fa-copy" @click="copy" :data-value="row.item.message"></i>
  </div>

  <a v-if="row.item.image" :href="row.item.image" target="_blank">
    <img :src="row.item.image" style="max-height: 100px;" >
  </a>
  <a v-if="row.item.file" :href="row.item.file" target="_blank">
    {{row.item.fileName}}
  </a>
  <a v-if="row.item.video" :href="row.item.video" target="_blank">
    Video
  </a>

  <span class="badge badge-info text-sm ml-1" v-if="row.item.templateName">{{row.item.templateName}}</span>
  <span class="badge badge-info text-sm ml-1" v-if="row.item.segment && isAdmin">{{row.item.segment}}</span>
  <span class="badge badge-info text-sm ml-1" v-if="row.item.price && isAdmin">${{row.item.price}}</span>

  <span class="badge badge-dark text-sm ml-1" 
      v-for="i in row.value.messageTags"
      v-if="row.value.hasMessageTags && isAdmin">
      <i class="fas fa-tag"></i>
      {{i}}
  </span> 
</template>

                </b-table>


              </div>
              <!-- table-responsive end -->

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :perPage="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  limit="10"
                ></b-pagination>
            </div>
          </div>
          <!-- card-body end -->
        </div>
      </div>
    </div>

    <br><br><br><br><br><br><br><br><br><br><br>
  </div>
</template>

<script>
  import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
  import * as lang from "vuejs-datepicker/src/locale";
  import moment from "moment";
  import _ from "lodash";
  import {
    get, chain, find,
  } from "lodash";
  import store from "../../store/store";
  import toast from "../../services/toast";
  import vSelect from "vue-select";

  const loadScript = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const {
    NODE_ENV
  } = process.env || {}

  export default {
    name: "messageHome",
    components: {
      Datepicker,
      vSelect,
    },
    beforeRouteEnter: function(to, from, next) {
      next((vm) => {});
    },

    async beforeCreate() {
      // Load Chart.js
      await loadScript(
        "https://cdn.jsdelivr.net/npm/chart.js@3.9.1/dist/chart.min.js"
      );

      // Load Chart.js datalabels plugin
      await loadScript(
        "https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@2.0.0"
      );

      Chart.register(ChartDataLabels);
    },

    async created(){
      let self = this

      self.clearFilters()
      try {
        let meta = JSON.parse(localStorage.getItem('carrierNameMap'))
        this.carrierNameMap = meta
        
        let availableSmsCountryCodes = JSON.parse(localStorage.getItem('availableSmsCountryCodes'))
        _.map(availableSmsCountryCodes, r => {
          self.countryCodes.push({
            value: `+${r}`,
            html: `+${r}`,
          })
        })
      }
      catch(err){console.error(err)}
      try {
        if (this.$route.query.filters){
          let query = JSON.parse(this.$route.query.filters)
          // console.log({
          //   // query: this.$route.query
          //   query,
          // })
          _.chain(this.filters).keys().map(filterKey => {
            if (_.has(query, filterKey)){
              this.filters[filterKey] = _.get(query, filterKey)
            }
          })
          .value()
        }
      }
      catch(err){
        console.error(err)
      }
      
      window.tmp = this
      this.isAdmin = !!_.get(store.getters, 'user.admin')
      if (this.isAdmin) {

        let [
          {
            data: {
              phoneNumberInventory = [],
              hostMapv2 = [],
            }
          },
          {
            data: {
              accounts = []
            }
          },
          {
            data: devices
          },
          {
            data: {
              queues = [],
            }
          }
        ] = await Promise.all([
          this.axios.get('/phoneNumberInventory', {params: {all: 1}}),
          this.axios.get('/accounts'),
          this.axios.get('/report/device', {
            params: {
              skipNotice: 1
            }
          }),
          this.axios.get('/whatsapp-agent/arena'),
        ])

        this.refreshPhoneInventoryUsage()

        this.accounts = accounts
        this.phones = phoneNumberInventory
        this.hostMapv2 = hostMapv2
        this.phones = _.map(this.phones, r => {
          // check if remark contains "RELEASED" (case sensitive)
          r.active = !_.includes(r.remark, 'RELEASED')
          r.waSharedFrom = _.get(r.settingParsed, 'shared.from', '')
          r.waSharedTo = _.join(_.get(r.settingParsed, 'shared.to'))

          return r
        })

        this.accountsOptions = chain(this.accounts)
          .filter({active: true})
          .map(account => {
            return {
              ...account,
              ...{
                // text: `${account.email} | ${account.currency} / ${_.round(account.balance, 1)}`,
                // value: account._id
              }
            }
          })
          // .unshift({
          //   text: this.txt('Any'),
          //   value: null
          // })
          .value()

        this.devices = chain(devices)
          .map(device => {
            device.queue = find(queues, queue => {
              return queue.name.includes(device._id)
            })
            return device
          }).value()

        console.log({devices, accounts, queues, devices2: this.devices})
      }
      else{
        _.remove(this.fields, {key: 'updatedAt'})
      }

      self.pageTimer = setInterval(() => {

        if (document.hidden){
          if (_.random(1, 100) < 90){
            console.log("window not active, skip reload");
            return 
          }
        }

        if (!self.isAdmin){
          return
        }

        this.refreshPhoneInventoryUsage()

        if (!self.autoRefresh){
          return 
        }
        if (_.size(self.selectedRows)){
          return 
        }
        let isUnselectRowsRecently = moment().diff(self.lastUnselectTime, 'seconds') < 30
        if (isUnselectRowsRecently){
          return 
        }
        
        self.searchRefresh('auto')
      }, 30 * 1000);
    },

    async mounted() {

      if (!$('#accordionSidebar').hasClass('toggled')){
        $('#accordionSidebar').addClass('toggled')
      }
      
      addEventListener('scroll', this._scrollHandler);
    },

    beforeDestroy() {
      console.warn('--beforeDestroy.')
      this.pageTimer && clearInterval(this.pageTimer)
      removeEventListener('scroll', this._scrollHandler);
    },

    data() {
      return {

        summary: null,
        chart: null,
        channelChart: null,
        priceChart: null,

        showModal: false,

        hostMapv2: [],

        stickSearch: false,
        blukControlStyle: '',

        selectedRows: [],
        selectedRowCount: 0,

        pageTimer: null, 

        accounts: [],
        devices: [],
        carrierNameMap: [],
        accountsOptions: [],
        messageDirectionOptions: [
          {
            value: null,
            html: this.txt('Any'),
          },
          {
            value: 'incoming',
            html: this.txt('Inbound'),
          },
          {
            value: 'outgoing',
            html: this.txt('Outbound'),
          },
        ],
        isAdmin: false,
        phones: [],
        phoneSelectedForTransfer: null,
        autoRefresh: true,
        lastRefreshed: 'NA',
        countryCodes: [
          {
            value: null,
            html: this.txt('Any'),
          },
          // {
          //   value: "+852",
          //   html: '+852',
          // },
          // {
          //   value: "+86",
          //   html: '+86',
          // },
          // {
          //   value: "+66",
          //   html: '+66',
          // },
          // {
          //   value: "+65",
          //   html: '+65',
          // },
          // {
          //   value: "+44",
          //   html: '+44',
          // },
          // {
          //   value: "+1",
          //   html: '+1',
          // },
          // {
          //   value: "+886",
          //   html: "+886",
          // },
        ],
        format: "yyyy-MM-dd",
        language: localStorage.getItem("activeLang").split("_")[0] || "zh",
        dLanguages: lang,
        id: "",
        dateFrom: moment().subtract(7, "day").toDate(),
        dateTo: moment().add(1, "day").toDate(),
        messages: [],
        tOffset: 0,
        fields: [{
            key: "_id",
            class: "redxx", // not working
            tdClass: "redxx", // not working
            thClass: "redxx", // not working
              // ok
              // thStyle: { 
              //   color: "red",
              //   width: "30px"
              // },
            sortable: true,
            label: this.txt("Message ID"),
            formatter: (value, key, item) => {
              let isTransferred = !!_.get(item, 'job.originalDeviceId')
              let usedDevice
              // if (isTransferred){
              let device = find(this.devices, {deviceId: _.get(item, 'job.deviceId')})
              usedDevice = _.get(device, 'phoneName')
              // }

              if (isTransferred && !usedDevice){
                usedDevice = 'Transferred'
              }

              // let device = _.find(this.devices, _.get(device, 'phoneName'))
              let novncLink, vncLink
              if (device){
                novncLink = `http://${device.host}:${_.toInteger(device.port) + 1000}`
                vncLink = `vnc://${device.host}:${device.port}`

                let hostMapV2Item = _.find(this.hostMapv2, {origin: device.host})
                let novncShortHost =  _.get(hostMapV2Item, 'novncShortHost')
                let novncHost =  _.get(hostMapV2Item, 'novnc')
                let novncPort = _.toString(_.toInteger(_.get(device, "port")) + 1000)
                novncLink = device.host
                  ? `https://${novncHost}/${novncShortHost}/${novncPort}/?path=socket_io%3Fport%3D${novncPort}%26host%3D${novncShortHost}&password=`
                  : null;
              }
              

              let tags = [], hasTags = false
              if (_.first(_.get(item, 'tags'))){
                tags = item.tags
                hasTags = true
              }


              // catagories tags
              // timing tags: last_sent-*, invalid_contact-*,
              // message tags: predict-
              let hasTimingTags = _.some(tags, r => r.includes('last_sent-') || r.includes('invalid_contact-'))
              let hasMessageTags = _.some(tags, r => r.includes('predict-'))
              let timingTags = _.filter(tags, r => r.includes('last_sent-') || r.includes('invalid_contact-'))
              let messageTags = _.filter(tags, r => r.includes('predict-'))

              let account = find(this.accounts, {_id: item.accountId})
              let accountUsername = _.get(account, 'username')
              
              return {
                id: item._id,
                jobId: _.get(item, "job._id"),
                isTransferred,
                usedDevice,
                novncLink,
                vncLink,
                item,
                tags,
                hasTags,

                hasTimingTags,
                hasMessageTags,
                timingTags,
                messageTags,
                accountUsername,
              };
            },
          },
  
          {
            key: "fromPhoneNumber",
            sortable: true,
            label: this.txt("Direction"),
            // label: this.txt("Sender"),
            formatter: (value, key, item) => {
              let parts = [];
  
              let fromPhone = item.fromPhoneCountryCode && item.fromPhoneNumber
                ? `+${item.fromPhoneCountryCode} ${item.fromPhoneNumber}`
                : "N/A";

              let toPhone = item.phoneCountryCode && item.phoneNumber
                ? `+${item.phoneCountryCode} ${item.phoneNumber}`
                : "N/A";

              let myPhone = item.type === "outgoing" ? fromPhone : toPhone
              let theirPhone = item.type === "outgoing" ? toPhone : fromPhone
              let myPhoneWaLink = `https://wa.me/${_.replace(myPhone, /\+|\s/g, '')}`
              let theirPhoneWaLink = `https://wa.me/${_.replace(theirPhone, /\+|\s/g, '')}`
              let myPhoneTLink = `https://t.me/${_.replace(myPhone, /\s/g, '')}`
              let theirPhoneTLink = `https://t.me/${_.replace(theirPhone, /\s/g, '')}`
  
              // parts.push(`+${item.phoneCountryCode}${item.phoneNumber}`)
              return {
                myPhone, 
                theirPhone,
                myPhoneWaLink,
                theirPhoneWaLink,
                myPhoneTLink,
                theirPhoneTLink,
                fromPhone,
                fromPhoneClass: item.type === "outgoing" ? 'text-primary' : '',
                toPhone,
                toPhoneClass: item.type !== "outgoing" ? 'text-primary' : '',
                iconClass: item.type === "outgoing" 
                  ? `<i class="fas fa-arrow-right text-success"></i>` 
                  : `<i class="fas fa-arrow-left text-danger"></i>`,
              };
              // return `<span v-html="${parts.join(' => ')}"></span>`
            },
            // formatter: (value, key, item) => {
            //   let parts = [];
  
            //   let fromPhone = "N/A";
            //   if (item.fromPhoneCountryCode && item.fromPhoneNumber) {
            //     fromPhone = `+${item.fromPhoneCountryCode} ${item.fromPhoneNumber}`;
            //   }
  
            //   parts.push(fromPhone);
            //   // parts.push(`+${item.phoneCountryCode}${item.phoneNumber}`)
            //   return {
            //     phone: parts.join(" => "),
            //     iconClass: item.type === "outgoing" ?
            //       `` : `<i class="fas fa-arrow-right text-danger"></i>`,
            //   };
            //   // return `<span v-html="${parts.join(' => ')}"></span>`
            // },
          },
  
          // {
          //   key: "phoneNumber",
          //   sortable: true,
          //   label: this.txt("TARGET"),
          //   formatter: (value, key, item) => {
          //     let parts = [];
  
          //     // let fromPhone = 'N/A'
          //     // if(item.fromPhoneCountryCode && item.fromPhoneNumber) {
          //     //     fromPhone = `+${item.fromPhoneCountryCode}${item.fromPhoneNumber}`
          //     // }
  
          //     // parts.push(fromPhone)
          //     parts.push(`+${item.phoneCountryCode} ${item.phoneNumber}`);
          //     return {
          //       phone: parts.join(" => "),
          //       iconClass: item.type === "outgoing" ?
          //         `<i class="fas fa-arrow-right text-success"></i>` : ``,
          //     };
          //     // return `<span v-html="${parts.join(' => ')}"></span>`
          //   },
          // },
          {
            key: "status",
            sortable: true,
            label: this.txt("STATUS"),
            formatter: (value, key, item) => {
              let displayText = _.upperCase(value);
              let isNewChat = !!_.get(item, 'job.requestNewChatAt')

              let durationClass, displayDuration, durationTitle
              if (_.has(item, 'job.updatedAt')) {
                durationClass = item.duration > 60 * 60 ? 'badge-danger' : (
                  item.duration > 30 * 60 ? 'badge-warning' : 'badge-success'
                )
                
                displayDuration = item.duration > 60 ? moment(item.createdAt).from(item.job.updatedAt) : `${item.duration}s`
                durationTitle = `${item.duration} second(s)`
              }

              return {
                isNewChat,
                displayDuration,
                durationClass,
                displayText,
                durationTitle,
                serverity: displayText === "SUCCESS" ?
                  "badge-success" : displayText === "FAILED" ?
                  "badge-danger" : displayText === "PENDING" ?
                  "badge-warning" : "badge-secondary",
                // className:
                //   displayText === "SUCCESS"
                //     ? "running"
                //     : displayText === "FAILED"
                //     ? "stopped"
                //     : displayText === "PENDING"
                //     ? "pending"
                //     : "",
                failedReason: displayText === "FAILED" ? _.get(item, "job.reason") : null,
              };
            },
          },
          {
            key: "createdAt",
            sortable: true,
            label: this.txt("CREATED"),
            formatter: (v) => moment(v).format("YYYY-MM-DD HH:mm:ss"),
          },
          {
            key: "updatedAt",
            sortable: true,
            label: this.txt("UPDATED"),
            formatter: (value, key, item) => {
              let v = _.get(item, 'job.updatedAt')
              if (!v){
                return
              }
              return moment(v).format("YYYY-MM-DD HH:mm:ss")
            },
          },
          {
            key: "channel",
            sortable: true,
            label: this.txt("Channel"),
            formatter: (value, key, item) => {
              return _.upperCase(value);
            },
          },
          {
            key: "message",
            tdClass: "messageCol",
            thClass: "messageCol",
            // style: 'width: 500px',
            // tdAttr: {
            //   colspan: 2
            // },
            // thAttr: {
            //   colspan: 2
            // },
            // thClass: "redxxx",
            // thStyle: {
            //     width: "50% !important",
            //     color: "blue",
            // },
            // tdStyle: {
            //     width: "50% !important",
            // },
            // width: '500px',
            sortable: false,
            label: this.txt("MESSAGE"),
            formatter: (value, key, item) => {
              let tags = _.get(item, 'tags')

              let hasTimingTags = _.some(tags, r => r.includes('last_sent-') || r.includes('invalid_contact-'))
              let hasMessageTags = _.some(tags, r => r.includes('predict-'))
              let timingTags = _.filter(tags, r => r.includes('last_sent-') || r.includes('invalid_contact-'))
              let messageTags = _.filter(tags, r => r.includes('predict-'))
              
              return {
                hasTimingTags,
                hasMessageTags,
                timingTags,
                messageTags,
              }
            },
          },
        ],
        isBusy: false,
        totalRows: 1,
        currentPage: 1,
        perPage: 50,
        messageTotal: 0,
        filters: {},
        lastFilters: null,
        sortBy: "createdAt",
        sortDesc: true,
        lastUnselectTime: moment(),
      };
    },
    methods: {
      renderChart() {
        if (!this.summary) return;
        
        const ctx = document.getElementById('messageStatsChart');
        if (!ctx) return;

        // Destroy existing chart
        if (this.chart) {
          this.chart.destroy();
        }

        let byAccount = _.get(this.summary, 'byAccount', [])
        byAccount.sort((a, b) => b.count - a.count);

        // Create new chart
        this.chart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: byAccount.map(item => item.username),
            datasets: [{
              label: 'Count',
              data: byAccount.map(item => item.count),
              backgroundColor: 'rgba(78, 115, 223, 0.8)',
              borderColor: 'rgba(78, 115, 223, 1)',
              borderWidth: 1
            }]
          },
          options: {
            maintainAspectRatio: false,
            responsive: true,
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  stepSize: 1
                }
              }
            },
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    return 'Count: ' + context.parsed.y;
                  }
                }
              },
              datalabels: {
                anchor: 'end',
                align: 'top',
                formatter: function(value) {
                  return value;
                },
                font: {
                  weight: 'bold',
                  size: 12
                }
              }
            }
          },
          plugins: [ChartDataLabels]
        });

        // channel chart
        const ctx2 = document.getElementById('messageChannelChart');
        if (!ctx2) return;

        if (this.channelChart) {
          this.channelChart.destroy();
        }

        let byChannel = _.get(this.summary, 'byChannel', [])
        byChannel.sort((a, b) => b.count - a.count);

        this.channelChart = new Chart(ctx2, {
          type: 'bar',
          data: {
            labels: byChannel.map(item => item.channel),
            datasets: [{
              label: 'Count',
              data: byChannel.map(item => item.count),
              backgroundColor: 'rgba(28, 200, 138, 0.8)',
              borderColor: 'rgba(28, 200, 138, 1)',
              borderWidth: 1
            }]
          },
          options: {
            maintainAspectRatio: false,
            responsive: true,
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  stepSize: 1
                }
              }
            },
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    return 'Count: ' + context.parsed.y;
                  }
                }
              },
              datalabels: {
                anchor: 'end',
                align: 'top',
                formatter: function(value) {
                  return value;
                },
                font: {
                  weight: 'bold',
                  size: 12
                }
              }
            }
          },
          plugins: [ChartDataLabels]
        });

        // price chart
        const ctx3 = document.getElementById('messagePriceChart');
        if (!ctx3) return;

        if (this.priceChart) {
          this.priceChart.destroy();
        }

        let byPrice = _.get(this.summary, 'byPrice', [])
        byPrice.sort((a, b) => b.price - a.price);

        this.priceChart = new Chart(ctx3, {
          type: 'bar',
          data: {
            labels: byPrice.map(item => item.username),
            datasets: [{
              label: 'Price',
              data: byPrice.map(item => item.price.toFixed(2)),
              backgroundColor: 'rgba(246, 194, 62, 0.8)',
              borderColor: 'rgba(246, 194, 62, 1)',
              borderWidth: 1
            }]
          },
          options: {
            maintainAspectRatio: false,
            responsive: true,
            scales: {
              y: {
                beginAtZero: true
              }
            },
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: function(context) {
                    return 'Price: ' + context.parsed.y;
                  }
                }
              },
              datalabels: {
                anchor: 'end',
                align: 'top',
                formatter: function(value) {
                  return value;
                },
                font: {
                  weight: 'bold',
                  size: 12
                }
              }
            }
          },
          plugins: [ChartDataLabels]
        });
      },
      _scrollHandler(event) {
        
        var offsets = document.getElementById('result-table').getBoundingClientRect();
        // console.log([
        //   window.scrollY,
        //   offsets.y,
        //   window.scrollY > offsets.y
        // ])
        if (window.scrollY > offsets.y){
          this.stickSearch = true
        }
        else {
          this.stickSearch = false
        }
      },
      /**
       * enrich this.phones[].usage info by GET /phoneInventory/usage
       */
      async refreshPhoneInventoryUsage(){
        let self = this
        let {data: {usage}} = await this.axios.get('/phoneNumberInventory/usage')
        // update phones[].usage reactively
        let newPhones = []
        _.map(self.phones, (phone, index) => {
          let u = _.find(usage, {phoneName: phone.name})
          if (phone){
            phone.usage = u
            // self.$set(self.phones, index, phone)
            // console.log(u.phoneName, phone)
          }
          newPhones.push(phone)
        })
        // console.log('----------phone', this.phones)
        this.phones = newPhones
      },
      // selectMethod(v){
      //   console.log(v)
      //   this.filters.method = v.value
      // },
      clearFilters(remember = false, submitSearch = false){
        let filterCleaned = {
          message: null,
          channel: null,
          countryCode: "+852",
          phoneNumber: null,
          _id: null,
          accountId: null,
          provider: null,
          phoneId: null,
          method: null,

          channel: "",
          status: "",
          type: null,
          carrierName: null,
          carrierNames: [],
        }

        let filterCurrent = {...this.filters}

        // console.log({filterCleaned})
        // console.log({filterCurrent})
        // console.log(
        //   _.difference(filterCurrent, filterCleaned),
        //   _.difference(filterCleaned, filterCurrent),
        //   JSON.stringify(filterCleaned) == JSON.stringify(filterCurrent)
        // )

        if (remember 
          && JSON.stringify(filterCleaned) !== JSON.stringify(filterCurrent)
        ){
          // this.lastFilters = {...this.filterCleaned}
        }
        
        this.filters = {...filterCleaned}

        if (submitSearch){
          this.searchRefresh('filter cleared')
        }
      },

      addMyPhoneToFilter(e, item){
        e.preventDefault()

        item = item.item
        
        if (item.type === 'incoming'){
          this.filters.phoneCountryCode = item.phoneCountryCode
          this.filters.phoneNumber = item.phoneNumber
         }
         else {
          this.filters.phoneCountryCode = item.fromPhoneCountryCode
          this.filters.phoneNumber = item.fromPhoneNumber
         }

        this.searchRefresh('filter update');
      },

      addTheirPhoneToFilter(e, item) {
        e.preventDefault()

        item = item.item
      
        if (item.type === 'outgoing'){
        this.filters.phoneCountryCode = item.phoneCountryCode
        this.filters.phoneNumber = item.phoneNumber
        }
        else {
        this.filters.phoneCountryCode = item.fromPhoneCountryCode
        this.filters.phoneNumber = item.fromPhoneNumber
        }

        this.searchRefresh('filter update');
      },

      async transferJobPreview(jobId) {
        let {data} = await this.axios.get(`/job/${jobId}/transferPreview`, {
          params: {
            includeSelf: true
          }
        })
        console.log(data)

        let phoneScores = _.get(data, 'phoneScores')
        // phoneScores = [
        //   {
        //     "queue": "device_60d2d8b511847c47f2f62230",
        //     "phoneName": "cmhk-13",
        //     "weight": 100,
        //     "transferJobRate": 1,
        //     "idealVolume": 80,
        //     "maxVolume": 80,
        //     "startedDays": 9152,
        //     "sentCount": 89,
        //     "pendingCount": 0,
        //     "stickyness": 0,
        //     "score": 26.8
        //   },]

        // pop over a table of phone scores
        let table = `
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Phone</th>
                <th>Score</th>
                <th>Weight</th>
                <th>Transfer Rate</th>
                <th>Volume</th>
                <th>Started</th>
                <th>Sent</th>
                <th>Pending</th>
                <th>Stickyness</th>
              </tr>
            </thead>
            <tbody>
              ${_.map(phoneScores, r => {
                return `
                  <tr>
                    <td>${r.phoneName}</td>
                    <td>${r.score}</td>
                    <td>${r.weight}</td>
                    <td>${r.transferJobRate}</td>
                    <td>${r.idealVolume}</td>
                    <td>${r.startedDays}</td>
                    <td>${r.sentCount}</td>
                    <td>${r.pendingCount}</td>
                    <td>${r.stickyness}</td>
                  </tr>
                `
              }).join('')}
            </tbody>
          </table>
        `

        this.showModal = true

        // insert table into modal .custom-content
        // $('.custom-content').html(table) // not working
        this.$nextTick(() => {
          $('.custom-content').html(table)
        })
        console.log(table)
      },

      async transferJob(item) {
        if (confirm('confirm ?')){
          // let parts =  split(get(item, 'job.deviceId'), '_')
          // let deviceId = _.last(parts)

          // console.log(get(item, 'job.deviceId'))
          let jobId = get(item, 'job._id')

          try {
            let {data} = await this.axios.post(`/job/${jobId}/transfer`)
            toast.success(JSON.stringify(data.toDevice.phoneName))
          }
          catch(err){
            // console.log(get(err, 'response.data.message'))
            toast.error(get(err, 'response.data.message', err.message))
          }
        }
      },
      async updateResult(item, result, bulk = false) {
        if (!bulk){
          if (!confirm(`confirm ${result}?`)){
            return 
          }
        }

        let jobId = get(item, 'job._id')

        let self = this
        let body = null
        if (result === 'failed'){
          body = {
            "reason": "invalid contact",
            "errorCode": "E_INVALID_CONTACT"
          }
        }

        let {data} = await this.axios.post(`/message/${jobId}/${result}`, {
          data: body
        })

        if (!bulk){
          toast.success('ok')
          this.searchRefresh('update result')
        }
      },
      async updateResultSelected(result) {
        if (!confirm(`confirm bulk ${result}?`)){
          return 
        }
        
        let self = this

        for (let i in self.selectedRows){
          let r = self.selectedRows[i]

          await self.updateResult(r, result, true)
        }
        // _.mapValues(self.selectedRows, async (r, index) => {
          
        // })

        await sleep(1000)

        toast.success(`updated ${_.size(self.selectedRows)} jobs, refreshing result`)
        this.clearSelectedRows()
        this.searchRefresh('update result - bulk')
      },
      async transferSelectedJob() {
        let self = this

        // TODO remove test
        // window.foo = self.$refs.table

        if (confirm('confirm bulk transfer ?')){

          for (let i in self.selectedRows){
            let r = self.selectedRows[i]

            let jobId = get(r, 'job._id')

            try {
              let requestBody
              if (!self.phoneSelectedForTransfer){
                requestBody = {}
              }
              else {
                requestBody = {
                  phoneName: self.phoneSelectedForTransfer
                }
              }
              // let {data} = await this.axios.post(`https://webhook.site/9cb95b3e-193e-4f8c-9c38-4dd9308eddf9?jobid=${jobId}`, requestBody)
                let {data} = await this.axios.post(`/job/${jobId}/transfer`, requestBody)

              // TODO remove test
              // test: success
              // let data = {
              //   toDevice: {
              //     phoneName: i
              //   }
              // }
              // await sleep(1000)

              // test: fail
              // throw new Error('test error')

              toast.success(_.get(data, 'toDevice.phoneName', '(phoneName not provided)'))
              // console.log({index}, r.index)

              // TODO minor: get index
              // self.$refs.table.unselectRow(_.toInteger(index))
            }
            catch(err){
              console.log(err)
              toast.error(get(err, 'response.data.message', err.message))
            }
          }
          // _.mapValues(self.selectedRows, async (r, index) => {
            
          // })

          await sleep(1000)

          toast.success(`transferred ${_.size(self.selectedRows)} jobs, refreshing result`)
          this.clearSelectedRows()
          this.searchRefresh('transfer - bulk')
        }
      },
      getAccountLabel(account) {
        if (!account._id){
          return this.txt('Any')
        }
        let username = account.username ? ` (${account.username})` : ''
        return `${account.email}${username} ${_.round(account.balance, 1)} sett=${account.currency}`
      },
      carrierNameOptions(){
        return _.chain(this.carrierNameMap)
        .map(r => {
          return {
            text: _.toUpper(r.short),
            value: r.short,
            label: _.toUpper(r.short),
          }
        })
        // .unshift({
        //   text: this.txt('Any'),
        //   value: null,
        //   label: this.txt('Any'),
        // })
        .value()
      },
      methodOptions(){
        // return _.map(['sim-modem', 'sim-web'], r => {
        return _.map([null, 'sim-modem', 'sim-web', 'gammu'], r => {
          return {
            text: _.chain(r).split('-').last().toUpper().value() || this.txt('Any'),
            value: r,
          }
        })
      },
      phoneOptions(){
        let phones = _.clone(this.phones)
        // filter out inactive
        // split phones into two tiers
        // 1. in-use
        // 2. not in-use
        let phones_1 = _.filter(phones, r => !!r.active && !!r.whatsappWebHost)
        
        let phones_2 = _.filter(phones, r => (
          // not in phone_1
          !_.find(phones_1, {name: r.name})
        ))
        phones = _.concat(null, phones_1, phones_2)

        // console.log(phones)
        return _.map(phones, r => {
          let waSharedFrom = _.get(r, 'waSharedFrom') ? ` (${_.get(r, 'waSharedFrom')})` : ''
          let text = _.toUpper(_.get(r, 'name'))  ? 
            `${_.toUpper(_.get(r, 'name'))}${waSharedFrom}`
            : this.txt('Any')

          return {
            text,
            value: _.get(r, '_id')
          }
        })
      },
      phoneForTransferOptions(){
        let phones = _.clone(this.phones)
        phones = _.filter(phones, r => (
          r.active && !r.whatsappSuspended && _.get(r, 'settingParsed.isTransferAvailable', true)
        ))
        phones = _.concat(null, phones)
        // console.log(phones)
        return _.map(phones, r => {
          let waSharedFrom = _.get(r, 'waSharedFrom') ? ` (${_.get(r, 'waSharedFrom')})` : ''
          let idealVolume = _.get(r, 'settingParsed.idealVolume', 0)
          let usage = _.get(r, 'usage.countNetShared', '-')
          // usage mark is the progress bar mark that indicate the rate of usage
          // e.g. ##### indicate more than 100% usage
          // e.g. ###-- indicate less than 3/5 usage
          // e.g. ----- indicate less than 1/5 usage
          let usageMark
          // indicate if phone usage is lower than idealVolume
          let lowerThanIdeal
          if (_.get(r, 'usage.countNetShared')){
            lowerThanIdeal = usage <= idealVolume
          }
          if (usage >= idealVolume){
            usageMark = _.repeat('#', 5)
          }
          else {
            let ratio = usage / idealVolume
            let ratioInt = _.toInteger(ratio * 5)
            let ratioRemain = 5 - ratioInt
            usageMark = _.repeat('#', ratioInt) + _.repeat('-', ratioRemain)
          }
          let text = _.toUpper(_.get(r, 'name'))  ? 
            `${_.toUpper(_.get(r, 'name'))} ${usageMark} [${usage}/${idealVolume}]${waSharedFrom}`
            : this.txt('Any')
            
            
          if (!r){
            return {
              text: this.txt('Auto'),
              value: null,
            }
          }

          return {
            text,
            value: _.get(r, 'name')
          }
        })
      },
      providerOptions(){
        return _.map([
            null,
            'accessyou', 
            'twilio', 
            'accessyou-supermeteor',
            'accessyou-supermeteor-marketing',
            'telnyx-supermeteor',
            'twilio-supermeteor',
            'nexmo-supermeteor',
            'messagebird-supermeteor',
          ], r => {
          return {
            text: _.toUpper(r) || this.txt('Any'),
            value: r,
          }
        })
      },
      getArenaUrlByMessage(message){
        let self = this
        
        let queueName
        if (message.channel === 'whatsapp'){
          let phoneNumber = `+${message.fromPhoneCountryCode}${message.fromPhoneNumber}`
          let deviceId = get(message, 'job.deviceId')
          let device = find(this.devices, {deviceId})
          if (!device){
            device = find(this.devices, {phoneNumber})
          }
          // console.log({device, message})

          if (!device){
            return 
          }

          // queueName = device.queue.name
          queueName = _.get(device, 'queue.name')
        }

        if (!queueName){
          return
        }

        if (message.channel === 'sms'){
          if (_.get(message, 'job.method') === 'sim-modem'){
            let phoneName = _.get(
              _.find(self.phones, {_id: _.get(message, 'job.phoneId')}),
              'name'
            )
            if (!phoneName){
              return 
            }

            queueName = `sms-${phoneName}`
          }
          else {
            let provider = _.get(message, 'job.provider')
            if (!provider){
              return 
            }
            queueName = `sms-${provider}`
          }
        }

        let jobId = message.job._id

        let arenaHost = this.env === 'prod' ? 'https://arena.supermeteor.com' : 'https://arena-uat.supermeteor.com'
        let arenaUrl = `${arenaHost}/${queueName}/${queueName}/${jobId}`
        return arenaUrl
      },

      copy(e) {
        window.foo = e
        console.log(e)
  
        // console.log(e.value.length)
        // e.target.select()
        // e.select()
  
        const el = document.createElement('textarea');
        el.value = get(e.target, 'dataset.value')
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
  
        toast.success(`Copied: ${el.value}`)
      },
  
      filterUpdate(filterType) {
        if (filterType === "latest_update") {
          // update table sort by updatedAt desc
          // this.$refs.table.sortBy("updatedAt", "desc");
          this.sortBy = "updatedAt";
        }
        if (filterType === "today") {
          this.dateFrom = moment().startOf("day").toDate();
          this.dateTo = moment().add(1, "day").startOf("day").toDate();
        }
        if (filterType === "yesterday") {
          this.dateFrom = moment().subtract(1, "day").startOf("day").toDate();
          this.dateTo = moment().startOf("day").toDate();
        }
        if (filterType === "recent") {
          this.dateFrom = moment().subtract(7, "day").startOf("day").toDate();
          this.dateTo = moment().add(1, "day").startOf("day").toDate();
        }
        if (filterType === "-1 Day") {
          this.dateFrom = moment(this.dateFrom)
            .subtract(1, "day")
            .startOf("day")
            .toDate();
          this.dateTo = moment(this.dateTo)
            .subtract(1, "day")
            .startOf("day")
            .toDate();
        }
        if (filterType === "+1 Day") {
          this.dateFrom = moment(this.dateFrom)
            .add(1, "day")
            .startOf("day")
            .toDate();
          this.dateTo = moment(this.dateTo).add(1, "day").startOf("day").toDate();
        }
  
        this.searchRefresh('filter update');
      },
      async searchRefresh(from) {
        console.log({
          from,
          filters: this.filters,
        });
        // console.log({filters: this.filters})
        try {
          await this.$router.push({
            path: this.$route.path,
            query: {filters: JSON.stringify(this.filters)}
          })
        }
        catch(err){
          // console.error(err)
          // console.error(err.message)
          // console.error(_.get(err, 'constructor.name'))
          // console.error(err.constructor.name)
        }
        
        _.get(this, '$refs.table.refresh') && this.$refs.table.refresh();

        toast.success(`refreshed, ${this.messageTotal} found`)
        this.lastRefreshed = moment().format('Y-MM-DD HH:mm:ss')
      },
      viewSearchHistory() {
        // open a modal, listing history of filters
        // TODO

        
      },
      selectAllRows(){
        this.$refs.table.selectAllRows()
      },
      clearSelectedRows(){
        this.$refs.table.clearSelected()
      },
      onRowSelected(items){
        this.selectedRows = items
        this.selectedRowCount = _.size(items)
        // console.log('onRowSelected', {items}, this.selectedRowCount)

        if (_.size(items) === 0){
          this.lastUnselectTime = moment()
        }
        
        let updateLayout = () => {
          
          // fit the width .bulk-control-inner to screen width
          let bulkControlInner = document.querySelector('.bulk-control-inner-tmp')
          // console.log('--1', `${document.body.clientWidth - 20}`)
          if (bulkControlInner){
            // TODO not working
            // get total inner element width
            let totalWidth = _.reduce(bulkControlInner.children, (sum, el) => {
              return sum + el.clientWidth * 1.4
            }, 0)
            bulkControlInner.style.width = `${totalWidth}px`
            // console.log('--2', totalWidth, bulkControlInner.style)
            this.bulkControlStyle = `width: ${totalWidth}px`
            // bulkControlInner.style.width = `${document.body.clientWidth - 20}px`

            // remove class bulk-control-inner
            bulkControlInner.classList.remove('bulk-control-inner-tmp')
          }

          // console.log(this.$refs)
          // console.log(this.$refs.transferButton)
          // https://stackoverflow.com/questions/51922767/autofocus-input-on-mount-vue-ios
          this.$nextTick(() => {
            // console.log('nextitck', this.$refs.transferButton)
            // not working
            this.$refs.transferButton && this.$refs.transferButton.focus()
          })
          // this.$refs.transferButton.focus()
        }

        // delay 50ms, ensure html rendered
        setTimeout(updateLayout, 200)

      },
      search(ctx) {

        let self = this

        this.isBusy = true;
        let aId = localStorage.getItem("accountId");
        let params = {};
  
        let url = `/account/${this.$store.getters.accountID}/messages`;
  
        let offset =
          this.currentPage === 1 ? 0 : (this.currentPage - 1) * this.perPage;
  
        params.limit = this.perPage;
        params.skip = offset;
        this.tOffset = offset;
        if (this.dateTo) {
          params.dateTo = moment(this.dateTo).format("YYYY-MM-DD");
        }
        if (this.dateFrom) {
          params.dateFrom = moment(this.dateFrom).format("YYYY-MM-DD");
        }
  
        if (ctx.sortBy) {
          params.sort = ctx.sortBy;
          params.order = ctx.sortDesc ? "desc" : "asc";
        }
  
        if (this.filters.status) {
          params.status = this.filters.status;
        }
  
        if (this.filters.channel) {
          params.channel = this.filters.channel;
        }
  
        if (this.filters.method) {
          params.method = this.filters.method;
        }
  
        if (this.filters.phoneNumber) {
          params.phone = `${this.filters.countryCode}${this.filters.phoneNumber}`;
        }

        if (this.filters.countryCode) {
          params.countryCode = `${this.filters.countryCode}`;
        }

        if (this.filters.phoneNumber) {
          params.phoneNumber = `${this.filters.phoneNumber}`;
        }
  
        if (this.filters.message) {
          params.message = this.filters.message;
        }

        if (this.filters.type) {
          params.type = this.filters.type;
        }
  
        if (this.filters._id) {
          params._id = this.filters._id;
        }
  
        if (this.filters.accountId) {
          params.accountId = this.filters.accountId;
        }
  
        if (this.filters.provider) {
          params.provider = this.filters.provider;
        }
  
        if (this.filters.phoneId) {
          params.phoneId = this.filters.phoneId;
        }

        if (this.filters.carrierName) {
          params.carrierName = this.filters.carrierName;
        }

        if (this.filters.carrierNames) {
          params.carrierNames = _.values(this.filters.carrierNames);
        }


        let foo = () => {
          return 'bar'
        }

        let getPhoneName = (row) => {
          return () => {
            // console.log(self.phones)
            
            return _.get(
              _.find(self.phones, {_id: _.get(row, 'job.phoneId')}),
              'name'
            )
          }
        }

        let getCarrierShortName = (row) => {
          
          return () => {
            let searchTerm = _.get(row, 'carrierName')

            if (!row){
              return searchTerm
            }
            
            try {
              let meta = this.carrierNameMap
              
              let match = _.find(meta, rs => {
                return _.indexOf(rs.long, searchTerm) > -1 || rs.short === searchTerm
              })
              
              return _.toUpper(_.get(match, 'short')) || searchTerm
            }
            catch(err){
              return searchTerm
            }
          }
        }

        // form a summary of filter as a text
        let filterSummary = []
        // for selected fields: status, channel, carrierName
        let selectedFields = ['phoneId', 'status', 'channel', 'carrierName']
        filterSummary = _.chain(selectedFields)
          .map((k) => {
            let v = _.get(self.filters, k)
            if (!v){
              return 
            }

            if (k === 'phoneId'){
              // get phone name by phoneId
              let phoneName = _.get(
                _.find(self.phones, {_id: v}),
                'name'
              )
              return phoneName
            }
            else {
              return v
            }
          })
          .filter()
          .value()
        // console.log({filterSummary})

        let title = `${_.size(filterSummary) ? `${filterSummary} - Message` : 'Message'}`
        // update page title
        document.title = title

  
  // console.log({params})
        return this.axios
          .get(url, {
            params,
          })
          .then((res) => {
            var items = _.map(res.data.messages, r => {
              r.foo = foo
              r.getPhoneName = getPhoneName(r)
              r.getCarrierShortName = getCarrierShortName(r)
              return r
            });

            this.messages = res.data.messages;
            this.messageTotal = res.data.total;
            this.totalRows = res.data.total;
            this.summary = res.data.summary;
            this.isBusy = false;
            items.map((x, i) => {
              // x.status = this.txt(x.status);
              x["fromPhone"] = "";
            });

            this.$nextTick(() => {
              this.renderChart();
            });
  
            return items || [];
          })
          .catch((err) => {
            this.isBusy = false;
            return [];
          });
      },
    },
  };
</script>

<style scoped>
table.b-table[aria-busy='true'] .spinner-border{
  margin: 100px 0 1000px
}
.messageCol > div{
  width: 350px
}
.bulk-control{
  padding: 10px 10px; 
  background: var(--gray);
  overflow-x: scroll
}
.bulk-control-inner{
  /* width: max-width; */
  /* width: 900px; */
  /* width: 620px; */
  overflow: auto;
}
#search-1.fixed-top{
  background: var(--gray);
  padding: 5px 5px
}
#search-1 .show-when-fixed{
  display: none
}
#search-1.fixed-top .show-when-fixed{
  display: block
}
#search-1 .hide-when-fixed{
  display: default
}
#search-1.fixed-top .hide-when-fixed{
  display: none
}
</style>